import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-proscanstatus',
  templateUrl: './proscanstatus.page.html',
  styleUrls: ['./proscanstatus.page.scss'],
})
export class ProscanstatusPage {
  // declare variables
  public date: any;
  public status_url = environment.proscanstatus;
  public assets = environment.assets;
  public refreshIcon = false;

  //constructor
  constructor() { }

  // does a refresh of the image
  public doRefresh() {
    this.refreshIcon = true;
    this.date = Date.now();
    setTimeout(() => {
      this.status_url = environment.proscanstatus + this.date;
      this.refreshIcon = false;
    }, 2000);
  }
}
